import { Component, OnInit } from '@angular/core';
import { RouteService } from '@services/route.service';
import { ProductService } from '@services/product.service';

@Component({
  selector: 'gob-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss']
})
export class ProductPageComponent implements OnInit {
  loading: boolean=false;

  constructor(public route: RouteService, private pServ: ProductService) { }

  ngOnInit(): void {
  }

  export(){
    this.loading=true;
    this.pServ.export().subscribe(() => this.loading=false);
  }

}
